<template>
  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title">Информация об аккаунте</h3>
    </div>

    <div v-loading="$mip('getAccInfo')" class="widget__body pb-12">
      <div class="row">
        <div class="col-md-6 stack-sm mb-12">
          <!-- E-MAIL -->
          <div>
            <span class="text-muted">E-mail: </span>{{ userData.email }}
          </div>
          <!-- ТАРИФ -->
          <div>
            <span class="text-muted">Тариф:</span> {{ accData.plan.name }} <span class="text-muted">до </span> {{ formatDate(accData.plan.expireDate) }}
          </div>
          <!-- УСЛУГИ -->
          <div>
            <span class="text-muted">Подключенные услуги: </span>
            <span v-for="(service, index) in accData.services" :key="service.id">
              {{ service.name }}<span v-if="index !== accData.services.length - 1">,</span>
            </span>
          </div>
          <!-- ПЛАТЕЛЬЩИК -->
          <div>
            <span class="text-muted">Плательщик: </span>{{ accData.payer.name }}
          </div>
        </div>
        <div class="col-md-6 stack-sm mb-12">
          <!-- ЕЖЕМЕСЯЧНЫЙ ПЛАТЕЖ -->
          <div>
            <span class="text-muted">Ежемесячный платеж: </span>{{ formatNumber(accData.monthlyPayment, 'currency') }}
          </div>
          <!-- БАЛАНС -->
          <div>
            <span class="text-muted">Текущий баланс: </span>{{ formatNumber(accData.balance, 'currency') }}
          </div>
          <!-- КОЛ-ВО ПОЛЬЗОВАТЕЛЕЙ -->
          <div>
            <span class="text-muted">Количество пользователей: </span>{{ accData.usersCount }}
          </div>
          <!-- СВОБОДНО -->
          <div>
            <span class="text-muted">Свободно: </span>
            {{ formatNumber(accData.storageEmpty, 'storage') }} из
            {{ formatNumber(accData.storageTotal, 'storage') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatNumber } from '@/utils'
  import { isEmpty } from 'lodash-es'
  import { formatDate } from '@/utils'

  export default {
    computed: {
      accData() {
        return this.$store.state.user.accInfo || {}
      },
      userData() {
        return this.$store.state.user.user || {}
      }
    },

    methods: {
      isEmpty,
      formatNumber,
      formatDate
    }
  }
</script>

<style lang="scss" scoped>
  .widget__title {
    margin-bottom: 12px;
    @media (min-width: $viewport-xs) {
      margin-bottom: 0;
    }
  }
</style>
